import {
  ACTION_ITEMS_V2_ON,
  HOSPITAL_SURGERY_LIST_ON,
  PAST_SURGERIES_ON,
  TURNAROUND_PAGE_FEATURE_FLAG,
} from 'featureFlags';
import { LocaleRoutes } from 'locale/locale';

export type NavigationItemLinkName = keyof LocaleRoutes;

/**
 * Generates the main menu items based on feature flags.
 *
 * @returns {NavigationItemLinkName[]} The array of navigation items.
 */
const getNavigationItems = (): NavigationItemLinkName[] => {
  const navigationItems: NavigationItemLinkName[] = [
    ACTION_ITEMS_V2_ON ? 'ActionItems' : 'ActionItemsV1',
    'Home',
    'Orders',
    PAST_SURGERIES_ON ? 'PastSurgeries' : 'PastDeliveries',
    'Contacts',
    'Reports',
    'UserPortal',
  ];

  if (HOSPITAL_SURGERY_LIST_ON) {
    const ordersIndex = navigationItems.indexOf('Orders');

    // Add SurgeryList after Orders
    navigationItems.splice(ordersIndex + 1, 0, 'SurgeryList');
  }

  if (TURNAROUND_PAGE_FEATURE_FLAG) {
    const historicalIndex = navigationItems.indexOf(PAST_SURGERIES_ON ? 'PastSurgeries' : 'PastDeliveries');

    // Add Turnaround before PastDeliveries
    navigationItems.splice(historicalIndex, 0, 'Turnaround');
  }

  return navigationItems;
};

export { getNavigationItems };
